<h2 mat-dialog-title>{{ 'actions.unlink_google' | translate }}<span class="icon-close icon-Cross" mat-dialog-close></span></h2>
<mat-dialog-content>
  <div class="dialog-content">
    <h3>{{ 'messages.unlink_google_confirmation_title' | translate: { email: data.email } }}</h3>
    <p>{{ 'messages.unlink_google_confirmation_message' | translate }}</p>
    <p>
      {{ 'messages.unlink_google_confirmation_hint' | translate }}
      <span>{{ 'messages.unlink_google_confirmation_path' | translate }}</span>
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button class="btn-main btn-secondary-purple btn-xl" (click)="confirm()">{{ 'actions.unlink_google' | translate }}</button>
  <button class="btn-main btn-primary btn-xl" mat-dialog-close>{{ 'actions.cancel' | translate }}</button>
</mat-dialog-actions>
